import { ActionIcon, Flex, Loader, Stack, TextInput } from '@mantine/core';
import React from 'react';
import IconError from '../../icons/IconError';
import { useDispatch } from 'react-redux';
import IconClose from '../../icons/IconClose';
import styles from './styles.scoped.css';
import Button from '../../elements/Button';
import IconSearch from '../../icons/IconSearch';
import PropTypes from 'prop-types';

const FormSearchUnblock = ({
  search = '',
  setSearch = () => {},
  handleSearch,
  data = {},
  placeholder = 'Masukkan NIK pelanggan...',
  btnSearchText = 'Cari Pelanggan',
  clearRedux = () => {},
  messageError = '',
  btnVariant
}) => {
  const dispatch = useDispatch();
  return (
    <Stack>
      <TextInput classNames={{
        error: 'errorInput'
      }} error={messageError && <span className={styles.errorWrapper}>
        <span><IconError/></span>
        <span>{messageError}</span>
      </span>} maxLength={16} onChange={({ currentTarget: { value } }) => {
        setSearch(value);
        if(data?.code === 404 || data?.code === 400){
          dispatch(clearRedux('search'));
        }
      }} placeholder={placeholder} rightSection={search.length > 0 ? <ActionIcon bg="transparent" onClick={() => {
        setSearch('');
        dispatch(clearRedux('search'));
      }}>
        <IconClose className={styles.iconClose}/>
      </ActionIcon>: null} styles={{
        root: {
          '[data-invalid]':{
            '::placeholder': {
              color: '#CF212A !important'
            },
            borderColor: '#CF212A'
          }
        }
      }} value={search} />
      <Button disabled={data?.loading} onClick={handleSearch} style={btnVariant}>
        <Flex align="center" gap="xs" justify="center">
          {data?.loading ? <Loader color="white" size="xs"/> : <IconSearch/>} {btnSearchText}
        </Flex>
      </Button>
    </Stack>
  );
};

export default FormSearchUnblock;

FormSearchUnblock.propTypes = {
  btnSearchText: PropTypes.string,
  btnVariant: PropTypes.string,
  clearRedux: PropTypes.func,
  data: PropTypes.object,
  handleSearch: PropTypes.func,
  messageError: PropTypes.string,
  placeholder: PropTypes.string,
  search: PropTypes.string,
  setSearch: PropTypes.func
};
